'use client'

import { AdProductContext } from '@/context/ad-product'
import { ChannelContextManager } from '@/context/channel-context'
import RouteContext from '@/context/route-context'
import { IChannel } from '@giphy/js-types'
import { ReactNode, createContext } from 'react'
import HeaderSearchBar from '../../components/search-bar'
import { useGA4 } from '../../util/analytics'
import type { TakeoverData } from '../util/searchbar-takeover'

type PageContextType = {
    hideSearchbar?: boolean
}

export const PageContext = createContext<PageContextType>({})

type Props = {
    children: ReactNode
    countryCode?: string
    takeover?: TakeoverData
    channel?: IChannel
    hideSearchbar?: boolean
    routeName: string
    stickyTopContent?: ReactNode
}

const GA4 = () => {
    useGA4()
    return null
}

const HeaderInit = ({ children, takeover, channel, hideSearchbar, routeName, stickyTopContent }: Props) => {
    return (
        <RouteContext.Provider value={{ route: routeName }}>
            <PageContext.Provider value={{ hideSearchbar }}>
                <ChannelContextManager channel={channel}>
                    <AdProductContext.Provider value={{ takeover }}>
                        <GA4 />
                        <HeaderSearchBar stickyTopContent={stickyTopContent}>{children}</HeaderSearchBar>
                    </AdProductContext.Provider>
                </ChannelContextManager>
            </PageContext.Provider>
        </RouteContext.Provider>
    )
}

export default HeaderInit
